<!--
 * @Author: cn1994
 * @Date: 2024-07-04 15:14:22
 * @LastEditors: cn1994
 * @LastEditTime: 2025-01-09 11:51:46
 * @Description: file content
-->
<!--
 * @Description: 加载组件封装
-->
<template>
  <div v-if="visible" class="loadingMask flex items-center justify-center">
    <slot>
      <div class="loading flex-1" v-loading="loading" :element-loading-text="text"></div>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      loading: false,
      loadingTime: null, // loading定时器
    };
  },
  watch: {
    visible: {
      immediate:true,
      handler(newVal){
        // 避免重复开启定时器
        if(this.loadingTime) {
          clearTimeout(this.loadingTime);
          this.loadingTime = null;
        }
        if(newVal) {
          this.loadingTime = setTimeout(()=>{
            this.loading = newVal;
          },500)
        } else {
          this.loading = newVal;
        }
      }
    },
  },
  methods: {},
};
</script>

<style lang="less" scoped>
  .loadingMask{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2000;
    .loading{
      height: 100%;
    }
  }
</style>